export default __webpack_public_path__ + "static/zitrone_02-3670c31d8c96d1049915ce3dc845b70f.png";